/**
 * Scroll the messages container so the START of a message is visible.
 *
 * A long answer appended at the bottom used to be scrolled to its end, so the
 * visitor had to scroll back up to read it from the beginning (TPA feedback,
 * slide 3). Aligning the message's top edge with the container's top keeps the
 * first line in view; the position is clamped so a short last message does not
 * leave empty space below it.
 */
export function scrollToMessageStart(container, messageEl) {
  if (!container || !messageEl) return;
  const maxTop = Math.max(0, (container.scrollHeight || 0) - (container.clientHeight || 0));
  const target = (messageEl.offsetTop || 0) - (container.offsetTop || 0);
  container.scrollTop = Math.min(Math.max(0, target), maxTop);
}
